export function getCustomHeaderName() {
  let headerName = import.meta.env.VITE_CUSTOM_HEADER_NAME;
  return headerName;
}

export function getCustomHeaderValue() {
  let headerValue = import.meta.env.VITE_CUSTOM_HEADER_VALUE;
  return headerValue;
}
